import { render, staticRenderFns } from "./wodeshequn.vue?vue&type=template&id=580e64b0&scoped=true"
import script from "./wodeshequn.vue?vue&type=script&lang=js"
export * from "./wodeshequn.vue?vue&type=script&lang=js"
import style0 from "./wodeshequn.vue?vue&type=style&index=0&id=580e64b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e64b0",
  null
  
)

export default component.exports